<template>
    <v-btn 
        :color="color" 
        @click="emit('clicked', $event)" 
        :small="small" 
        :x-small="xSmall"
        :loading="loading"
        v-bind="$attrs" 
        v-on="$listeners"
    >
        <slot>{{ label }}</slot>
    </v-btn>
</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    label: { type: String, default: 'Clique aqui' },
    color: { type: String, default: 'primary' },
    small: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
})

const emit = defineEmits(['clicked'])

</script>